<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>Modifica</title>
    <path
      d="M19.339 19.589H15.2a.75.75 0 1 1 0-1.5h4.139a.75.75 0 1 1 0 1.5zm-10.142 0H4.661a.75.75 0 0 1-.75-.75v-4.535a1.74 1.74 0 0 1 .513-1.238l5.604-5.604h.001l2.829-2.829a.75.75 0 0 1 1.061 0l4.949 4.95a.75.75 0 0 1 0 1.061l-2.828 2.829h0l-5.606 5.606a1.74 1.74 0 0 1-1.238.513zm-3.786-1.5h3.786a.25.25 0 0 0 .177-.073l5.077-5.076-3.89-3.889-5.076 5.076a.25.25 0 0 0-.073.177v3.785zm6.21-10.099l3.89 3.889 1.768-1.768-3.889-3.889-1.769 1.768z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
